<script lang="ts">
import { defineComponent, PropType } from 'vue'
import SolutionContentsCard from '@/components/solutions/SolutionContentsCard.vue'

export default defineComponent({
  name: 'SymbolicSolutionContentSection',

  components: {
    SolutionContentsCard,
  },

  props: {
    item: {
      type: Object as PropType<SolutionContentItem>,
      required: true,
    },

    header: {
      type: String,
      default: '',
    },

    to: {
      type: String,
      default: '',
    },
  },
})
</script>

<template>
  <section class="section">
    <div
      v-if="header"
      class="o-heading__section">
      <h2 class="o-heading__section--item">
        {{ header }}
      </h2>
    <!-- /.o-heading__section --></div>

    <SolutionContentsCard
      :item="item"
      :horizontal="{
        pc: true,
        sp: true,
      }" />

    <p
      v-if="to"
      class="p u-text__right">
      <a
        class="a u-action__forward"
        :href="to">
        その他の{{ header || 'コンテンツ' }}はこちら
      </a>
    </p>
  </section>
</template>

<style lang="sass" scoped>
// object
.o-heading__section
  margin-bottom: 2em
  padding: 0.75em 1.25em
  background-color: rgba($bg-x-light-orange, 1)
  border-left: 3px solid $border-orange

  &:last-child
    margin-bottom: 0

  & &--item
    line-height: 1.6
    font:
      size: $font-huge
      weight: bold
</style>
